// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"201083cf","453":"8edb6d34","455":"6fb57655"}[chunkId] + ".chunk.js";
};